import classNames from 'classnames';
import { FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { BonusOrdinalRatingEnum } from '@sorare/core/src/__generated__/globalTypes';
import { CollectionArrow } from '@sorare/core/src/atoms/icons/CollectionArrow';
import { BrandXXS } from '@sorare/core/src/atoms/typography';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';

const StyledChip = styled(Chip)`
  background: rgba(var(--color), 0.2);
  color: rgb(var(--color));
  gap: 2px;

  &.EXCEPTIONAL {
    --color: var(--c-rgb-score-high);
  }
  &.VERY_HIGH {
    --color: var(--c-rgb-score-mediumHigh);
  }
  &.HIGH {
    --color: var(--c-rgb-score-medium);
  }
  &.MEDIUM {
    --color: var(--c-rgb-score-mediumLow);
  }
  &.LOW {
    --color: var(--c-rgb-score-low);
  }
  &.VERY_LOW {
    --color: var(--c-rgb-score-veryLow);
  }
`;

type Props = {
  bonusRating: BonusOrdinalRatingEnum | null;
  bonus?: number;
};

export const ContenderBonus = ({ bonusRating, bonus }: Props) => {
  return (
    <StyledChip size="small" className={classNames(bonusRating)}>
      <CollectionArrow size={1} color="currentColor" />
      {typeof bonus === 'number' && (
        <BrandXXS color="currentColor">
          <FormattedNumber value={bonus} maximumFractionDigits={0} />
        </BrandXXS>
      )}
    </StyledChip>
  );
};
